module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Shovel-663348154c9b022c8edf2216668f40d0.svg";